<app-breadcrumb master="Administracja" parentName="Szablony" name="Sczegóły"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-template-details-view [template]="template" *ngIf="!modify" (modifyClicked)="modify = true"></app-template-details-view>
    <app-template-add *ngIf="modify" [template]="template" (closeModification)="modify = false; loadTemplate()"></app-template-add>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [template]="template"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
